module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_8023.68f02809.png";